import { ADMINS_MA_DEALS_DETAILS_PATH, ADMINS_MA_DEALS_PATH } from '@/utils/constants';
import { Route, Switch } from 'react-router-dom';

import { MaDealDetails } from './components/MaDealDetails';
import { MaDealsList } from './components/MaDealsList';

export const MaDeals = () => {
  return (
    <Switch>
      <Route exact path={ADMINS_MA_DEALS_PATH} component={MaDealsList} />
      <Route exact path={ADMINS_MA_DEALS_DETAILS_PATH} component={MaDealDetails} />
    </Switch>
  );
};
